import React from 'react'
import { Box, Flex, Divider, Text } from '@chakra-ui/react'
import ProjectCard from './ProjectCard'
import PlayListifyImg from "../assets/images/PlayListify-Demo.png"
import DiveChatImg from "../assets/images/dive-chat-demo.png"
import MyntraDemo from "../assets/images/Myntra-demo.png"

const ProjectSection = () => {
    return (
        <Box
            w="85%"
            mt="10rem"
            px="6.5rem"

        >
            <Flex
                justifyContent="flex-start"
                alignItems="center"
                mb="1.5rem"
                fontSize="1.5rem"
            >
                02.{" "}
                <Text
                    pl="0.5rem"
                    pr="1rem"
                    fontSize="1.75rem"
                    fontWeight="700"
                    color="text.light"
                    as={"span"}
                >
                    Projects
                </Text>
                <Divider w="40%" opacity="0.3" />
            </Flex>
            <ProjectCard
                title="PlayListify"
                description="PlayListify is a web app using which spotify users can create playlists of the top tracks and top artitst they listen on spotify.
                    You just need to login through your spotify account, and you can create playlist with
                    just a single click."
                tools={["React", "Tailwind CSS", "Node", "Express", "Spotify Web API"]} 
                img={PlayListifyImg}
                githubLink="https://github.com/chetas411/playListify-Frontend"
                liveLink="https://playlistifyweb.netlify.app"
            />
            <ProjectCard
                title="Dive Chat"
                description="Peer to Peer chatting app with read reciepts built from scratch using Firebase real time database.
                Sign Up / Log in with email and password and chat with active users along with message
                sent, received and seen feature"
                tools={["React", "Material UI", "Firebase"]} 
                img={DiveChatImg}
                githubLink="https://github.com/chetas411/Dive-Chat"
                liveLink="https://real-time-chat-19b13.web.app/"
            />
            <ProjectCard
                title="Myntra Clone (MVP)"
                description="Implementation of Myntra E-Commerce as a MVP with filters and sorting functionalities along with cart in React with vanilla CSS.
                You can filter, sort and search the products."
                tools={["React", "Redux", "Vanilla CSS"]}
                img={MyntraDemo}
                githubLink="https://github.com/chetas411/Myntra-Clone-in-React"
                liveLink="https://myntra-clone-in-react.vercel.app/"
            />
        </Box>
    )
}

export default ProjectSection